export default __webpack_public_path__ + "static/media/temp-12.b6721f87.svg";